import {
  Box,
  Container,
  Group,
  Text,
  Avatar,
  Badge,
  Menu,
  UnstyledButton,
} from '@mantine/core';
import {
  IconUser,
  IconCreditCard,
  IconRobot,
  IconPuzzle,
  IconLogout,
  IconChevronDown,
} from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import { ManifestusLogo } from './ManifestusLogo';
import { trackNavClick } from '../../analytics';

const activeStyle: React.CSSProperties = {
  backgroundColor: 'rgba(124, 58, 237, 0.06)',
  color: '#7c3aed',
};

export function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box
      py="sm"
      style={{
        borderBottom: '1px solid rgba(0,0,0,.06)',
        background: 'rgba(255,255,255,.85)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <Container size={960} px="md">
        <Group justify="space-between">
          <Group gap={10} align="center" style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
            <ManifestusLogo h={20} />
            <Badge variant="light" color="violet" size="xs" radius="xl" style={{ textTransform: 'none', fontWeight: 500, fontSize: 10, paddingInline: 8 }}>
              Alpha
            </Badge>
          </Group>

          <Menu shadow="md" width={180} position="bottom-end">
            <Menu.Target>
              <UnstyledButton>
                <Group gap="xs">
                  <Avatar src={user?.photoUrl || null} radius="xl" size="sm" color="manifestusPurple">
                    {user?.firstName?.[0]?.toUpperCase() || '?'}
                  </Avatar>
                  <Text size="sm" c="#64748b" visibleFrom="sm">{user?.firstName}</Text>
                  <IconChevronDown size={14} color="#94a3b8" />
                </Group>
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                leftSection={<IconUser size={14} />}
                onClick={() => { trackNavClick('profile'); navigate('/profile'); }}
                style={location.pathname === '/profile' ? activeStyle : undefined}
              >
                Profile
              </Menu.Item>
              <Menu.Item
                leftSection={<IconRobot size={14} />}
                onClick={() => { trackNavClick('agents'); navigate('/dashboard'); }}
                style={location.pathname === '/dashboard' ? activeStyle : undefined}
              >
                Manifestant
              </Menu.Item>
              <Menu.Item
                leftSection={<IconPuzzle size={14} />}
                onClick={() => { trackNavClick('toolkit'); navigate('/skills'); }}
                style={location.pathname === '/skills' ? activeStyle : undefined}
              >
                Toolkit
              </Menu.Item>
              <Menu.Item
                leftSection={<IconCreditCard size={14} />}
                onClick={() => { trackNavClick('billing'); navigate('/billing'); }}
                style={location.pathname === '/billing' ? activeStyle : undefined}
              >
                Billing
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item color="red" leftSection={<IconLogout size={14} />} onClick={() => { trackNavClick('logout'); handleLogout(); }}>
                Logout
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Container>
    </Box>
  );
}
